<template>
    <div class="container-deployment-image" :style="isClick ? 'cursor:pointer': ''" @click="emitToClick">
        <div
            :class="['selected-point', {'pulse-effect': isBallPulse}]"
            :style="{width: sizeBall + 'px', height: sizeBall + 'px'}"
        >
            <div
                class="point-value"
                :style="{
                    'background': setColor.color
                }"
            >
                <span
                    class="value"
                    :style="{
                        'color': getContrastColor(setColor.color),
                        'font-size': sizeBall*0.40 + 'px'
                    }"
                >
                    {{ data.number }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'balls-image',
        props: {
            data: {
                type: Object,
                required: true
            },
            isClick: {
                type: Boolean,
                default: false
            },
            sizeBall: {
                type: null,
                default: 28
            },
            setColor: {
                type: Object,
                default: () => {}
            },
            isBallPulse: {
                type: Boolean,
                default: false
            }
        },

        methods: {
            emitToClick() {
                this.$emit('input', this.data)
            },

            getContrastColor(hexColor, threshold = 150) {
                // Converte a cor hexadecimal para RGB
                const rgbColor = this.hexToRgb(hexColor);

                // Calcula a luminância usando a fórmula de W3C
                const luminance = 0.2126 * rgbColor.r + 0.7152 * rgbColor.g + 0.0722 * rgbColor.b;

                // Determina se a cor é clara ou escura com base no limiar
                return luminance < threshold ? '#FFFFFF' : '#000000';
            },
            hexToRgb(hex) {
                // Remove o "#" se presente
                let ishex = hex.replace(/^#/, '');

                // Converte o valor hexadecimal para RGB
                const bigint = parseInt(ishex, 16);
                const r = (bigint >> 16) & 255;
                const g = (bigint >> 8) & 255;
                const b = bigint & 255;

                return { r, g, b };
            }
        },
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>